import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { MasterPeriodIdentifierModel } from '../models/masterPeriodIdentifier.model';
import { InfraService } from './infra.service';

@Injectable()
export class MasterPeriodIdentifierService {

  
  private configCoreUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
   
    this.infraService.infraDetails$.subscribe(data => {
      
      this.configCoreUrl = data.WebEndPoint2 + 'PeriodIdentifier';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

  }

  public getP13Periods(): Observable<MasterPeriodIdentifierModel[]> {
    return this.http.get<MasterPeriodIdentifierModel[]>(`${this.configCoreUrl}` + '/' + 'getP13Periods');
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
